import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';


const decode = (status: number, data: ResponseType): unknown => {
    if (status === 200) {
        return;
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface PostWithdrawalReviewType {
    transactionId: number,
    card: string,
    accountId: number,
    note: string | null
}

export const postWithdrawalReview = {
    browser: {
        params: (params: PostWithdrawalReviewType): ParamsFetchType<PostWithdrawalReviewType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/review-withdrawal',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/review-withdrawal',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<PostWithdrawalReviewType>): Promise<GenerateUrlApiType> => {

        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                }
            };
        }

        const { transactionId, card, accountId, note } = params.req.body;

        return {
            url: `${params.API_URL}/review-withdrawal/${params.API_UNIVERSE}/${transactionId}`,
            passToBackend: true,
            method: MethodType.POST,
            body: {
                card: card,
                accountId: accountId,
                ruleType: 'review',
                amount: 0,
                reason: [],
                note: note,
            }
        };
    }
};

